<template>
  <div class="main-body">
    <div class="header">老人列表</div>
    <div class="out">
      <div class="search2">

        <el-button plain size="mini" type="primary" @click.native="toggleModalAdd">添加</el-button>
        <el-button plain size="mini" type="success" icon="el-icon-upload" @click="batchDialog=true">批量添加</el-button>

        <div style="float:right">
          <el-input size="mini" placeholder="输入姓名" v-model="name" clearable style="width:120px;margin-right:10px"></el-input>
          <el-input size="mini" placeholder="输入手机号" v-model="phone" maxlength="11" clearable style="width:150px;margin-right:10px"></el-input>
          <el-select size="mini" v-model="status" placeholder="请选择状态" style="width:150px;margin-right:10px">
            <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                        placeholder="选择所属区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                        style="width:140px;margin-right:10px"></elSelectTree>
          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList">搜索</el-button></div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" ref="table" border stripe
                show-summary :summary-method="getTotal"
                v-loading="loading" :row-class-name="tableRowClassName">

        <el-table-column prop="name" fixed="left" label="姓名" width="100"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="150"></el-table-column>
        <el-table-column prop="idCard" label="身份证" width="200"></el-table-column>
        <el-table-column prop="urgencyContact" label="紧急联系人" width="120"></el-table-column>
        <el-table-column prop="urgencyPhone" label="紧急联系人手机" width="150"></el-table-column>

        <el-table-column prop="elderlyFund.balance" label="余额" width="100"></el-table-column>

        <el-table-column prop="status" label="状态" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">默认</span>
            <span v-if="scope.row.status == 1">正常</span>
            <span v-if="scope.row.status == 2">禁用</span>
          </template>
        </el-table-column>

        <el-table-column prop="zoneName" label="区域" width="300" ></el-table-column>
        <el-table-column prop="homeAddress" label="住址" width="300" ></el-table-column>
        <el-table-column prop="elderlyClassName" label="分类" width="100" ></el-table-column>
        <el-table-column prop="institutionName" label="照料机构" width="300" ></el-table-column>

        <el-table-column prop="createTime" :formatter="getTime" label="注册时间" min-width="180"></el-table-column>
        <el-table-column fixed="right" label="操作" width="280">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑 </el-button>
            <el-button type="success" size="mini" @click="DeviceManage(scope.$index, scope.row)">设备</el-button>
            <el-button type="warning" size="mini" @click="handleView(scope.row)">档案 </el-button>
            <el-button size="mini" @click="handleIns(scope.row)">机构</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>

    <ViewInfo ref="myViewInfo" v-show="showModalView" v-on:closeView="closeView" v-on:getList="getList"></ViewInfo>
    <OldManFile ref="myOldManFile" v-show="showModalOldManFile" v-on:closeInfo="closeOldManFile" v-on:getList="getList"></OldManFile>

    <PageForDevice ref="myPageForDevice" v-show="showModalDevice"  v-on:closeDevice="closeDevice"  v-on:getList="getList"   ></PageForDevice>


    <el-dialog title="批量添加" @close='closeBatchDialog'  :visible.sync="batchDialog" class="dialog" width='450px' center top='30vh' :close-on-click-modal='false'>
      <el-upload
          class="upload-demo"
          ref="upload"
          :action="uploadUrl"
          :data='uploadData'
          :on-success="uploadSuccess"
          :file-list="batchFileList"
          style="text-align: center;"
          :auto-upload="false"
          :limit='1'>
        <el-button slot="trigger" type="primary">选取文件</el-button>
        <el-button  style="margin-left: 25px;" type="success" @click="getTemplate">下载模板</el-button>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog=false">取 消</el-button>
        <el-button type="primary"  @click="submitUpload">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入失败"  :visible.sync="batchDialogError" class="dialog" width='550px' center :close-on-click-modal='false'>
      <div style="max-height:350px;overflow-y: auto;">
        <div style="margin-bottom:10px" v-for="(item,i) in errorData" :key="i">
          <p v-show="/\d/.test(item)" style="line-height: 25px;">{{item}}</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialogError=false">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="绑定IC卡" :visible.sync="ICCardDialog" class="dialog" width='450px'
               center top='30vh' :close-on-click-modal='false'>
      <div class="label">IC卡号:</div>
      <el-input v-model.trim="icCard" placeholder="请用读卡器读取Ic卡"
                style="margin-top:10px"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary"  @click="bindSubmit">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑机构" :visible.sync="InsDialog" class="dialog" width='450px'
               center top='30vh' :close-on-click-modal='false'>

      <el-select v-model="institutionCode" placeholder="请选择机构" style="width:100%">
        <el-option
            v-for="item in institutions"
            :key="item.institutionCode"
            :label="item.userName"
            :value="item.institutionCode">
        </el-option>
      </el-select>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary"  @click="InsSubmit">保存</el-button>
      </div>

    </el-dialog>

    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";
import elderly from "@/common/status";

import Edit from "./Edit2";
import Add from "./Add2";

import OldManFile from "./OldManFile";
import ViewInfo from "../PageForGov/ViewInfo2";

import PageForDevice from "@/views/Elderly/PageForGov/PageForDevice";
import elSelectTree from "@/components/ElSelectTree"

export default {
  name: "Role",
  data() {
    return {

      uploadUrl:this.$shopUrl+'ImportElderly/Import',
      uploadData:{
        staffCode:getStaffCode(),
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
      },
      batchFileList:[],

      ICCardDialog:false,
      icCard:'',

      InsDialog:false,
      institutionCode:'',
      institutions:[],

      elderlyCode:'',

      batchDialog:false,
      batchDialogError:false,

      errorData:[],

      showModal:false,
      showModalDevice:false,
      censusRegister:'',
      loading: false,

      showModalAdd: false,
      showModalEdit: false,
      showModalOldManFile: false,
      showModalView:false,

      datetimerangeValue: '',

      showModalSearch: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      name: '',
      idCard: '',

      ctiyDate: [],
      elderlyType: elderly.serviceType,
      elderlyClassValue: [],
      nationValue: [],
      zoneValue: [],
      areaValue: [],
      zoneCode: '',
      elderlyAllType: elderly,

      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        label: 'name',
        children: 'listZoneDTO'
      },
      phone: '',
      elderlyClassList:'',
      elderlyClass:-1,
      censusRegisterList:['城市','农村'],
      status:-1,
      statusList: [
        {
          value: -1, label: '全部状态'
        }, {
          value: 1, label: '正常'
        }, {
          value: 2, label: '禁用'
        }
      ],

      balanceAll:0,

    }
  },
  components: {
    Edit,PageForDevice,Add,OldManFile,elSelectTree,ViewInfo
  },

  created() {
    this.init();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  methods: {
    init: function () {

      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 365);
      this.datetimerangeValue = [start, end];

      this.getZonList();
      this.getList();

    },

    getClassList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ElderlyClass/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.elderlyClassValue = response.data.data;

              var  elderlyClassValue1=[];
              elderlyClassValue1.push({label:'全部分类' ,value:-1 })
              for (let i in this.elderlyClassValue){
                let j={label:this.elderlyClassValue[i].name ,value:this.elderlyClassValue[i].value }
                elderlyClassValue1.push(j)
              }
              this.elderlyClassValue=elderlyClassValue1

            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },

    getZonList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              var data = JSON.stringify(response.data.data);
              data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
              //console.log(data);
              this.zoneValue = data;
              //this.zoneCode=data[0].zoneCode;
              //this.getList();

            } else if (response.data.error == 1) {
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


    closeBatchDialog(){
      this.$refs.upload.clearFiles();
    },
    uploadSuccess(response){
      //console.log(response);
      if(response.error === 0){
        this.batchDialog=false
        this.uuid = response.data;

        this.crontab();

      }else if(response.error === 1){
        this.$message.error(response.message)
      }
    },
    getZoneValue(val) {
      this.zoneCode = val
    },
    getTime(row,index,column){
      return timefilters(column)
    },

    tableRowClassName({row}) {
      const timeAudit = new Date(row.timeAudit);
      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 30);
      if (timeAudit >= start) {
        return 'success-row';
      }
      return '';
    },


    submitUpload(){
      //console.log(this.batchFileList);

      this.showModal=true
      this.$refs.upload.submit();

    },
    crontab() {
      this.timer = setInterval(this.getSuccess, 1000 * 1);
    },
    getSuccess() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ImportElderly/IsSuccess",
        data: {
          uuid: this.uuid
        }
      }).then((response) => {
        if (response.data.error === 0) {

          this.showModal=true
          this.isSuccess = response.data.data;

          if (this.isSuccess === "0") {
            this.showModal=true
          }

          if (this.isSuccess === "1") {
            this.$message({type: 'success', message: '导入成功'});
            this.showModal=false
            this.getList();
            this.inCrontab();

          }
          if (this.isSuccess === "2") {
            this.$message({type: 'error', message: '导入失败'});
            this.inCrontab();
            this.showModal=false
          }
          if (this.isSuccess !== "1" && this.isSuccess !== "2" && this.isSuccess !== "0") {
            if(this.isSuccess.length>10){
              this.batchDialogError=true
              this.errorData=this.isSuccess.split('<br>')
            }else{
              this.$message.error({type: 'success', message: this.isSuccess});
            }

            this.inCrontab();
            this.showModal=false
          }


        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        } else if (response.data.error === 2) {
          this.$message({type: 'success', message: '导入失败'});
          this.inCrontab();
          this.showModal=false
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    inCrontab() {
      clearInterval(this.timer);
    },
    getTemplate(){
      var that=this
      this.$axios.get(this.$shopUrl+'ImportElderly/Template',{
        responseType: 'blob',
        params:{
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
            let fileName = '老人导入模板.xlsx';
            that.file(response,fileName);
          })
    },
    file(response, fileName) {
      let blob = new Blob([response.data]);
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        let elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      }
    },




    handleIns(row){
      this.InsDialog=true;
      if(row.institutionCode){
        this.institutionCode=row.institutionCode
      }else{
        this.institutionCode=''
      }
      this.elderlyCode=row.elderlyCode;
      this.getIns();
    },
    getIns(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Institution/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.institutions = response.data.data.list;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    InsSubmit(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Elderly/UpdateIns",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          institutionCode:this.institutionCode,
          elderlyCode:this.elderlyCode
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.InsDialog=false
          this.getList()
          this.$message({type: 'success', message: '保存成功'});
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        console.log(error);
      });
    },





    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit(row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },

    handleView(row) {
      this.$refs.myViewInfo.init(row);
      this.showModalView = !this.showModalView;
    },
    closeView(){
      this.showModalView = !this.showModalView;
    },


    handleInfo(row) {
      this.$refs.myOldManFile.init(row);
      this.showModalOldManFile = !this.showModalOldManFile;
    },
    closeOldManFile(){
      this.showModalOldManFile = !this.showModalOldManFile;
    },


    DeviceManage(index, row){
      this.$refs.myPageForDevice.init(row);
      this.showModalDevice = !this.showModalDevice;
    },
    closeDevice:function (){
      this.showModalDevice = !this.showModalDevice;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.loading=true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Elderly/GovPage",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),

          pageIndex: this.currentPage,
          pageSize: this.pageSize,

          name:this.name,
          phone: this.phone,
          status:this.status,
          zoneCode:this.zoneCode
        }
      }).then((response) => {

        this.loading=false;
        if (response.data.error == 0) {

          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
          this.balanceAll = response.data.data.balanceAll;

          this.$nextTick(()=>{this.$refs.table.doLayout()});

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        this.loading=false;
        console.log(error);
      });
    },
    getTotal(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 5) {
          sums[index] = this.balanceAll;
          return;
        }
        // const values = data.map(item => Number(item[column.property]));
        // if (column.property === 'balance') {
        //     sums[index] = values.reduce((prev, curr) => {
        //     const value = Number(curr);
        //     if (!isNaN(value)) {
        //         return this.tableData[3];
        //     } else {
        //         return this.tableData[0];
        //     }
        //     }, 0);
        //     sums[index];
        // } else {
        //     sums[index] = '';
        // }
      });
      return sums;
    },




  }
}
</script>
<style>
.el-table .success-row {
  background: #f0f9eb;
}
</style>
<style   lang="scss" scoped>
.mask {
  background-color: rgb(0, 0, 0);
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199
}
.mask .lodingsIcon{
  /* margin-top: 47vh; */
  margin: 47vh auto;
  height: 6vh;
  width: 300px;
  font-size: 18px;
  color: white;
}
.lodingsIcon i{
  z-index: 200;
  font-size: 25px;
  margin-right:10px ;

}

.label{
  padding: 5px 0px;
}
</style>
